import { makeStyles, Theme } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginRight: "2rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
